const DASH = 4;
const GAP = 3;
const CARD_RADIUS = 12;

// Inset by half the stroke so the 1px line stays inside the box and lands on whole pixels.
const CardDashedBorder = () => (
	<svg
		aria-hidden
		className="pointer-events-none absolute left-[0.5px] top-[0.5px] h-[calc(100%-1px)] w-[calc(100%-1px)] overflow-visible stroke-primary-border"
	>
		<rect
			fill="none"
			height="100%"
			rx={CARD_RADIUS}
			strokeDasharray={`${DASH} ${GAP}`}
			strokeWidth={1}
			width="100%"
		/>
	</svg>
);

export default CardDashedBorder;
